///////////////////////////////////////////////////////////////////
// Progress broadcast

export const LIKE_SECTION_POPUP_TOGGLE = "LIKE_SECTION_POPUP_TOGGLE";
export interface LikeSectionPopupToggleAction {
    readonly type: typeof LIKE_SECTION_POPUP_TOGGLE;
    readonly entityType: string;
    readonly entityId: number;
}
export const likeSectionPopupToggle = (
    entityType: string,
    entityId: number,
): LikeSectionPopupToggleAction => ({
    type: LIKE_SECTION_POPUP_TOGGLE,
    entityType,
    entityId,
});
